<template>
  <div class="dpv-list page page-with-table p-2">
    <div class="card content-wrapper p-2">
      <DpvTable/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import DpvTable from "@/modules/dpv/DpvTable";
  import {SOURCE_AUCTION_DPV_TABLE} from "../../../constants";

  const {mapActions} = createNamespacedHelpers('dpv/dpv');
  const {mapState} = createNamespacedHelpers('sales');

  export default {
    name: "Dpv",
    components: {PageHeader, DpvTable},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale,
      }),
    },
    methods: {
      ...mapActions(['updateTableSource']),
    },
    async beforeMount() {
      await this.updateTableSource({source: SOURCE_AUCTION_DPV_TABLE, auctionUuid: this.sale.uuid});
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";

  .dpv-list {
    @include list-view-wrapper;
  }
</style>
